module.exports = __webpack_public_path__ + "bg_panflet_mama.cd757e99.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/parent_to_child/bg_panflet_mama.png
// module id = /KIb
// module chunks = 0